import { Component } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { NearbyEventNew, ParticipantSearchListModel } from '../../../providers/event/event';
import { NearbyEventParticipantSearchPage } from '../nearby-event-participant-search/nearby-event-participant-search';

/**
 * Generated class for the NearbyEventParticipantsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


/*
  ATTENTION!
  This page is no longer used from build 1.1.94.
  The component is merged into NearbyEventParticipantSearch
*/

@Component({
  selector: 'page-nearby-event-participants',
  templateUrl: 'nearby-event-participants.html',
})
export class NearbyEventParticipantsPage {

  activeItem: NearbyEventNew;
  constructor(public navCtrl: NavController, public navParams: NavParams, private app: App) {
    this.activeItem = navParams.data.activeItem;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NearbyEventParticipantsPage');

  }

  remove(participant: ParticipantSearchListModel) {
    this.activeItem.participants.splice(
      this.activeItem.participants.findIndex(x => x.lid === participant.lid)
      , 1);
  }

  showSearch() {

    (this.app.getRootNav() as NavController).push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem });

  }



}



// WEBPACK FOOTER //
// /src/pages/nearby/nearby-event-participants/nearby-event-participants.ts